import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from "recharts";
import { DNA_AXES, getCategoryColor } from "../lib/constants";

/**
 * 10-axis Gin DNA radar chart. Supports up to 3 overlays for Compare.
 * Data shape: [{ dna: {...}, color: '#xxx', name: 'Gin name' }, ...]
 */
export default function DnaRadar({ items = [], height = 320, showLegend = false }) {
  const data = DNA_AXES.map((a) => {
    const row = { axis: a.label };
    items.forEach((it, idx) => {
      row[`v${idx}`] = it.dna[a.key] || 0;
    });
    return row;
  });

  return (
    <div className="w-full" style={{ height }} data-testid="dna-radar">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="76%">
          <PolarGrid stroke="rgba(245,242,235,0.12)" />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fill: "rgba(245,242,235,0.7)", fontSize: 11, fontFamily: "Outfit, sans-serif" }}
          />
          <PolarRadiusAxis angle={90} domain={[0, 5]} tick={false} axisLine={false} />
          {items.map((it, idx) => {
            const color = it.color || getCategoryColor(it.category || "classic");
            return (
              <Radar
                key={idx}
                name={it.name}
                dataKey={`v${idx}`}
                stroke={color}
                fill={color}
                fillOpacity={0.22}
                strokeWidth={1.6}
                isAnimationActive={true}
                animationDuration={800}
              />
            );
          })}
          {showLegend && (
            <Tooltip
              contentStyle={{ background: "#15171A", border: "1px solid rgba(193,127,89,0.5)", color: "#F5F2EB" }}
            />
          )}
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
